import type { FeatureMiddleware } from '@cast/api-client';
import {
  demoClusterNodeConfigList,
  demoClusterNodeConfigMaxPodsFormulaPresets,
  demoClusterNodeConfigSuggestions,
} from '@cast/fixtures';

import {
  getIsClusterDemoMode,
  getIsOpDemoMode,
} from '@cast/infrastructure-demo';

import { rejectDemoClusterRequest } from '../utils';

export const nodeConfigTemplates: FeatureMiddleware<'nodeConfigTemplates'> = {
  listNodeConfigTemplates: async ({ next, resolve }) => {
    if (getIsOpDemoMode()) {
      return resolve({ items: [] });
    }
    if (getIsClusterDemoMode()) {
      const fixture = await demoClusterNodeConfigList();
      return resolve(fixture);
    }
    return next();
  },
  getNodeConfigTemplate: async ({ args, next, resolve }) => {
    if (getIsClusterDemoMode()) {
      const fixtures = await demoClusterNodeConfigList();
      const fixture = fixtures.items?.find((item) => item.id === args[0].id);
      return resolve(fixture!);
    }
    return next();
  },
  createNodeConfigTemplate: async ({ next }) => {
    if (getIsClusterDemoMode() || getIsOpDemoMode()) {
      return rejectDemoClusterRequest();
    }
    return next();
  },
  deleteNodeConfigTemplate: async ({ next }) => {
    if (getIsClusterDemoMode() || getIsOpDemoMode()) {
      return rejectDemoClusterRequest();
    }
    return next();
  },
  updateNodeConfigTemplate: async ({ next }) => {
    if (getIsClusterDemoMode() || getIsOpDemoMode()) {
      return rejectDemoClusterRequest();
    }
    return next();
  },
  setDefaultNodeConfigTemplate: async ({ next }) => {
    if (getIsClusterDemoMode() || getIsOpDemoMode()) {
      return rejectDemoClusterRequest();
    }
    return next();
  },
  getNodeConfigSuggestions: async ({ next, resolve }) => {
    if (getIsClusterDemoMode()) {
      const fixture = await demoClusterNodeConfigSuggestions();
      return resolve(fixture);
    }
    return next();
  },
  getMaxPodsFormulaPresets: async ({ next, resolve }) => {
    if (getIsClusterDemoMode()) {
      const fixture = await demoClusterNodeConfigMaxPodsFormulaPresets();
      return resolve(fixture);
    }
    return next();
  },
};
